import { render, staticRenderFns } from "./OfflineCardRecord.vue?vue&type=template&id=671bb8f0&"
import script from "./OfflineCardRecord.vue?vue&type=script&lang=js&"
export * from "./OfflineCardRecord.vue?vue&type=script&lang=js&"
import style0 from "./OfflineCardRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports